'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSearch;

var _api = require('../api');

var Api = _interopRequireWildcard(_api);

var _ResultsCollection = require('../collections/ResultsCollection');

var _ResultsCollection2 = _interopRequireDefault(_ResultsCollection);

var _config = require('../config');

var _constants = require('../constants');

var _helpers = require('../helpers');

var _dateUtils = require('../helpers/dateUtils');

var _filters = require('../helpers/filters');

var _TimeManager = require('../helpers/TimeManager');

var _TimeManager2 = _interopRequireDefault(_TimeManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var searchIdParam = 'session_id'; // 'search_id';
var defaultOptions = {
  sortType: _constants.ORDERING.ORDER_NONE,
  maxSearchTime: 60 * 1000, // milliseconds
  maxResults: null,
  maxResultsByRequest: null,
  pageSize: 24
};

function calculateProgress(totalResultsLength, startTime) {
  var resultsProgress = totalResultsLength && totalResultsLength / 60;
  var timeProgress = startTime ? (Date.now() - startTime) / this.options.maxSearchTime : 0;

  return Math.min(100, Math.round(Math.max(resultsProgress, timeProgress) * 100));
}

function checkSearchesIds(data) {
  if (data.data[searchIdParam] !== this.currentSearchID) {
    var _data;

    return {
      msg: 'mistmatch_ids',
      data: (_data = {}, _defineProperty(_data, searchIdParam, data.data[searchIdParam]), _defineProperty(_data, 'current_search_id', this.currentSearchID), _data)
    };
  }
  return data;
}

function handleResponseSearch(data) {
  var _data$data = data.data,
      search_id = _data$data.search_id,
      session_id = _data$data.session_id,
      polygon = _data$data.polygon,
      is_cached = _data$data.is_cached,
      destination = _data$data.destination;


  this.currentSearchID = data.data[searchIdParam];
  this.startData = { search_id: search_id, session_id: session_id, is_cached: is_cached, destination: destination, polygon: polygon };
  (0, _config.setConfig)({ SEARCH_POLYGON: polygon });
  this.dispatch(_constants.EVENTS.START, this.startData);
  return data;
}

function parseEstablishments(data) {
  var responseData = data.data;
  var results = responseData.results;
  var grouped = (0, _helpers.groupBy)(results, 'type');
  var newDate = Date.now();
  var numberOfDays = (0, _dateUtils.datesDiff)(this.currentSearchParamsObject.date_arrival_timestamp || newDate, this.currentSearchParamsObject.date_leaving_timestamp || newDate);
  if (this.options.filter) {
    grouped.ESTAB = grouped.ESTAB ? grouped.ESTAB.filter(this.options.filter) : grouped.ESTAB;
    grouped.VACATION_RENTAL = grouped.VACATION_RENTAL ? grouped.VACATION_RENTAL.filter(this.options.filter) : grouped.VACATION_RENTAL;
    grouped.HOTEL = grouped.HOTEL ? grouped.HOTEL.filter(this.options.filter) : grouped.HOTEL;
  }

  var parsedResults = this.establishments.append(grouped);
  parsedResults = this.establishments.addPrices(grouped, parsedResults, this.currentSearchParamsObject.date_arrival_timestamp, numberOfDays);

  var isSortTime = this.sortTimeManager.isTime();
  var returnObj = {
    search_id: responseData.search_id,
    session_id: responseData.session_id,
    search_progress: calculateProgress.call(this, this.establishments.collection.length, this.searchStartTime),
    _internal_search_id: responseData[searchIdParam],
    _internal_current_search_id: this.currentSearchID,
    results: parsedResults,
    visible: isSortTime
  };

  // Sort at fibonacci
  if (isSortTime) this.establishments.sort(this.options.sortType);

  return returnObj;
}

function handleResponsePrices(data) {
  if (data.msg === 'mistmatch_ids') {
    console.warn('search[' + data.data[searchIdParam] + '] -- refused', data.msg);
    return 'mistmatch_ids';
  }

  if (data.msg === 'no_data') {
    this.dispatch(_constants.EVENTS.COMPLETE, this.establishments.sort(this.options.sortType));
    return 'no_data';
  }

  if (this.searchCancelled) return 'cancelled';

  if (data.data && data.data.results && data.data.results.length) {
    this.dispatch(_constants.EVENTS.PROGRESS, parseEstablishments.call(this, data));
  }

  if (this.options.maxSearchTime && Date.now() >= this.options.maxSearchTime || this.options.maxResults && this.establishments.collection.length >= this.options.maxResults) {
    this.dispatch(_constants.EVENTS.COMPLETE, this.establishments.sort(this.options.sortType));
    return 'complete';
  }

  var _data$data2 = data.data,
      search_id = _data$data2.search_id,
      session_id = _data$data2.session_id;

  var options = this.options.maxResultsByRequest ? { limit: this.options.maxResultsByRequest } : {};

  Api.getPricesRequest(search_id, session_id, data.data.tms, options).then(checkSearchesIds.bind(this)).then(handleResponsePrices.bind(this));

  return 'get_data';
}

var Search = function () {
  function Search() {
    _classCallCheck(this, Search);

    this.currentSearchID = null;
    this.establishments = new _ResultsCollection2.default();
    this.visibleEstablishments = [];
    this.options = defaultOptions;
    this.sortTimeManager = null;
    this.searchCancelled = false;
  }

  _createClass(Search, [{
    key: 'cancelSearch',
    value: function cancelSearch() {
      this.currentSearchID = null;
      this.searchCancelled = true;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params) {
      if (!params) {
        throw new Error('Must provide search params!!!');
      }

      this.cancelSearch();
      this.searchCancelled = false;

      for (var _len = arguments.length, extra = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        extra[_key - 1] = arguments[_key];
      }

      if (extra[0] && extra[0].initState) this.establishments.reset(extra[0].initState);else this.establishments.reset();

      this.options = defaultOptions;
      this.currentSearchParamsObject = _extends({}, params);
      this.currentSearchParams = (0, _helpers.checkSearchArguments)(params);

      // Handle options
      if ((0, _helpers.getType)(extra[0]) === '[object Object]') {
        this.options = _extends({}, defaultOptions, extra[0]);
        extra.shift();
      }

      this.sortTimeManager = new _TimeManager2.default();

      // Set Options
      if (this.options.maxSearchTime) {
        this.options.maxSearchTime = Date.now() + this.options.maxSearchTime;
      }

      this.searchStartTime = Date.now();
      this.startData = null;
      var options = this.options.maxResultsByRequest ? { limit: this.options.maxResultsByRequest } : {};
      Api.createSearch(this.currentSearchParams, options).then(handleResponseSearch.bind(this)).then(checkSearchesIds.bind(this)).then(handleResponsePrices.bind(this));
    }
  }, {
    key: 'removeEstablishment',
    value: function removeEstablishment(id) {
      var index = this.visibleEstablishments.indexOf(id);
      if (index > -1) this.visibleEstablishments.splice(index, 1);
      this.establishments.remove(id);
      return this.visibleEstablishments;
    }
  }, {
    key: 'addRecommendation',
    value: function addRecommendation(id) {
      this.establishments.addRecommendation(id);
    }
  }, {
    key: 'dispatch',
    value: function dispatch(eventName) {
      var _eventCb;

      var eventCb = (_eventCb = {}, _defineProperty(_eventCb, _constants.EVENTS.START, this.onStart), _defineProperty(_eventCb, _constants.EVENTS.PROGRESS, this.onProgress), _defineProperty(_eventCb, _constants.EVENTS.COMPLETE, this.onComplete), _defineProperty(_eventCb, _constants.EVENTS.ERROR, this.onError), _eventCb);

      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      eventCb[eventName].apply(this, args);
    }
  }, {
    key: 'sort',
    value: function sort(_sortType) {
      var exists = Object.keys(_constants.ORDERING).some(function (ord) {
        return _sortType === _constants.ORDERING[ord];
      });

      this.options.sortType = exists ? _sortType : this.options.sortType;
      return this.establishments.sort(this.options.sortType);
    }
  }, {
    key: 'filter',
    value: function filter(params, persist) {
      var establishments = (0, _filters.filterAll)(this.establishments.collection, this.establishments.dictionary, params);
      if (persist) {
        this.visibleEstablishments = establishments;
      }
      return establishments;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return this.establishments.toJSON();
    }
  }, {
    key: 'toArray',
    value: function toArray() {
      return this.establishments.collection;
    }
  }, {
    key: 'toObject',
    value: function toObject() {
      return this.establishments.dictionary;
    }
  }, {
    key: 'getPage',
    value: function getPage(currentPage) {
      var totalPages = Math.ceil(this.visibleEstablishments.length / this.options.pageSize);
      var firstIndex = Math.min(currentPage, totalPages - 1) * this.options.pageSize;
      var lastIndex = firstIndex + this.options.pageSize;
      return {
        visibleEstablishments: this.visibleEstablishments.slice(firstIndex, lastIndex),
        numEstablishments: this.visibleEstablishments.length
      };
    }
  }, {
    key: 'onStart',
    value: function onStart() {}
  }, {
    key: 'onProgress',
    value: function onProgress() {}
  }, {
    key: 'onComplete',
    value: function onComplete() {}
  }, {
    key: 'onError',
    value: function onError() {}
  }]);

  return Search;
}();

function createSearch() {
  return new Search();
}